var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720.2 800",
    style: {
      enableBackground: "new 0 0 720.2 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M703.3,51.7c-46.6-25-96.7-38.3-153.3-38.3c-66.6,0-133.3,18.3-196.6,35s-121.7,33.4-180,33.4 c-38.9,0-74.1-7.5-106.7-22.4v-26C66.7,15.1,51.7,0,33.4,0S0,15.1,0,33.4v733.3C0,784.9,15.1,800,33.4,800s33.4-15.1,33.4-33.4 V524.5c32.7,11.3,67.4,17.2,105,17.2c66.6,0,133.3-18.3,196.6-33.4c63.3-16.7,121.7-33.4,180-33.4c45,0,85.1,10,121.7,29.9 c20.8,14.2,50.1-3.4,50.1-28.3V81.6C719.8,68.4,713.3,58.4,703.3,51.7z M653.3,423.4c-33.4-11.6-68.4-16.7-105-16.7 c-66.6,0-133.3,18.3-196.6,35c-63.3,16.7-121.7,33.4-180,33.4c-38.3,0-73.3-6.7-105-21.6V130.1c33.4,11.6,68.4,16.7,105,16.7 c66.6,0,133.3-18.3,196.6-35s121.7-33.4,180-33.4c38.3,0,73.3,6.7,105,21.6V423.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag_icon.e0f8206d.svg";
export { ForwardRef as ReactComponent };